import Checkout from '@frontend/screens/Checkout'
import Home from '@frontend/screens/Home'
import ProductCategory from '@frontend/screens/ProductCategory'
import SearchResult from '@frontend/screens/SearchResult'
import Shop from '@frontend/screens/Shop'
import Single from '@frontend/screens/Single'
import SingleProduct from '@frontend/screens/SingleProduct'
import Stories from '@frontend/screens/Stories'
import Wishlist from '@frontend/screens/Wishlist'
import { NextUIProvider } from '@nextui-org/react'
import { TOAST_OPTIONS } from '@shared/constant'
import NotFound from '@shared/screens/NotFound'
import React from 'react'
import { Toaster } from 'react-hot-toast'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom'
import { SWRConfig } from 'swr'

import { ConfirmationDialogProvider } from '../shared/features/confirm-modal/ConfirmationDialog'
import '../shared/libs/i18n'
import Layout, { LayoutTemplateEnum } from './layout/Layout'
import Cart from './screens/Cart'
import ChineseNewYear from './screens/ChineseNewYear'
import ConfirmPayment from './screens/ConfirmPayment'
import Coupon from './screens/my-account/Coupon'
import LostPassword from './screens/my-account/LostPassword'
import MyAccount from './screens/my-account/MyAccount'
import OrderHistory from './screens/my-account/OrderHistory'
import OrderHistoryDetail from './screens/my-account/OrderHistoryDetail'
import PaymentHistory from './screens/my-account/PaymentHistory'
import PersonalInformation from './screens/my-account/PersonalInformation'
import PointsAndRewards from './screens/my-account/PointsAndRewards'
import ShippingAddress from './screens/my-account/ShippingAddress'
import OrderReceived from './screens/OrderReceived'
import SingleLookBook from './screens/SingleLookBook'
import SpecialPrice from './screens/SpecialPrice'
import StoreLocator from './screens/StoreLocator'
import WhiteAsava from './screens/WhiteAsava'

const useSWRConfig = () => ({
  fetcher: (resource: RequestInfo, init?: RequestInit) =>
    fetch(resource, init).then((res) => res.json()),
  revalidateOnFocus: true,
})

const createAppRoutes = () =>
  createRoutesFromElements(
    <>
      <Route element={<Layout />} path="/">
        <Route element={<NotFound />} path="*" />
        <Route element={<Home />} index />
        <Route element={<Single />} path=":slug" />
        <Route element={<SingleProduct />} path="product/:slug" />
        <Route element={<SingleLookBook />} path="look-book/:slug" />
        <Route element={<Single />} path="store-locator/:slug" />
        <Route element={<Shop />} path="shop" />
        <Route element={<Stories />} path="stories" />
        <Route element={<Wishlist />} path="wishlist" />
        <Route element={<SearchResult />} path="search/*" />
        <Route element={<ProductCategory />} path="product-category/*" />
        <Route element={<ConfirmPayment />} path="confirm-payment" />
        <Route element={<SpecialPrice />} path="/special-price" />
        <Route element={<StoreLocator />} path="/stores" />
        <Route element={<WhiteAsava />} path="/white-asava" />
        <Route element={<ChineseNewYear />} path="chinese-new-year" />
        {/*
                    TODO: Add missing routes
                    - /category/press/
                    - /stores/
                    - /store-locator/headquarter/
                    - /?s=*
                    - /special-price/
                    - /brands/*
                    - /my-account/
                    - /my-account/*
                */}
      </Route>
      <Route element={<Layout />} path="my-account">
        <Route element={<LostPassword />} path="lost-password" />
        <Route element={<MyAccount />} index />
        <Route element={<Layout template={LayoutTemplateEnum.MY_ACCOUNT} />}>
          <Route element={<PersonalInformation />} path="edit-account" />
          <Route element={<OrderHistory />} path="orders" />
          <Route element={<OrderHistoryDetail />} path="view-order/:orderId" />
          <Route element={<ShippingAddress />} path="edit-address" />
          <Route element={<PaymentHistory />} path="payment-history" />
          <Route element={<Coupon />} path="coupons" />
          <Route element={<PointsAndRewards />} path="points-and-rewards" />
        </Route>
      </Route>
      {/* <Route
        element={<Layout template={LayoutTemplateEnum.CHECKOUT} />}
        path="/"
      >
        <Route element={<Cart />} path="cart" />
        <Route element={<Checkout />} path="checkout" />
        <Route
          element={<OrderReceived />}
          path="checkout/order-received/:orderId"
        />
      </Route> */}
    </>,
  )

export const App = () => {
  const router = createBrowserRouter(createAppRoutes())
  const swrConfig = useSWRConfig()

  return (
    <React.StrictMode>
      <SWRConfig value={swrConfig}>
        <Toaster
          position="top-center"
          reverseOrder={false}
          toastOptions={TOAST_OPTIONS}
        />
        <NextUIProvider>
          <ConfirmationDialogProvider>
            <RouterProvider router={router} />
          </ConfirmationDialogProvider>
        </NextUIProvider>
      </SWRConfig>
    </React.StrictMode>
  )
}

export default App
